import { RudderEventData } from '@/types'

const fireRudderstackEvent = (rudderstack: RudderEventData) => {
  if (rudderstack.subType) {
    const event = rudderstack.subType
    window.rudderanalytics?.track(event, rudderstack)
  }
}

export default fireRudderstackEvent
